export class bazaryab_admin_controller {
    loadComplete = false;
    user: any;
    loading: boolean = true
    constructor(private $user, private $ocLazyLoad, private $state, private $mdSidenav) {
        "ngInject"

    }
    $onInit() {
        this.$user.getInfo().then(
            user => {
                if (user.data) {
                    this.$ocLazyLoad.load("bazaryab-admin").then(res => {
                        this.loadComplete = true
                        if (this.$state.current.name.indexOf('bazaryab_admin') == -1) {
                            this.$state.go('bazaryab_admin.vendors')
                        }
                    })
                    this.user = user.data;
                }
                else {
                    window.location.href = '/login?returnUrl=/DesktopModules/ECBMainStore/ECBMainAdmin/VendorAdmin.aspx'
                }
                this.loading = false;
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/bazaryab-admin/bazaryab-admin.controller.ts